import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Change,
  Reset,
} from "../../../store/async-actions/digitalmarketing/header";

import Pagination from "../../../Component/DigitalMarketing/Pagination";
import DashTable from "./DashTable";
import DashTabs from "./DashTabs";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { Button } from "@mui/material";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import { useGetMedicineMastersQuery } from "../../../Service/MedicineMaster";
import MedicineDetails from "./MedicineDetails";
import Loader from "../../../Component/DigitalMarketing/Loader";
export const initialMedicine = {
  activeStatus: 1,
  manufacturing: "",
  medicineDose: "",
  medicineName: "",
  medicineType: "",
  branchId:""
};
function Medicinemaster() {
  const [pagination, setpagination] = useState(1);
  const [filter, setFilter] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [show, setshow] = useState(false);
  const [Show, setShow] = useState(false);
  const [filteredValues, setFilteredValues] = useState(null);

  const [created, setCreated] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch<any>();
  const [medicine, setMedicine] = useState(initialMedicine);

  const [open, setOpen] = useState(false);
  const { open: open1, message, openSnackBar, type } = useSnackbar();

  const handleOpen = () => {
    setOpen(true);
  };
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const {
    data: medicines,
    isLoading,
    refetch,
  } = useGetMedicineMastersQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  // console.log(medicines);

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setpagination(1);
    refetch();
  }, [filter, searchValue]);
  useEffect(() => {
    // console.log("created 11111111");
    if (created === true) {
      openSnackBar("Added successfully");

      setTimeout(() => {
        //  console.log("created 222222");

        refetch();
        setCreated(false);
      }, 1000);
    }
  }, [created]);
  useEffect(() => {
    // console.log("updated 11111111");
    if (updated === true) {
      openSnackBar("Updated successfully");

      setTimeout(() => {
        //  console.log("updated 222222");

        refetch();
        setUpdated(false);
      }, 1000);
    }
  }, [updated]);
  useEffect(() => {
    // console.log("updated 11111111");
    if (deleted === true) {
      openSnackBar("Deleted successfully", "error");

      setTimeout(() => {
        //  console.log("updated 222222");

        refetch();
        setDeleted(false);
      }, 1000);
    }
  }, [deleted]);

  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);

  const onFilter = (value) => {
    if (value === "All") {
      setFilter("");
    } else {
      setFilter(value);
    }
  };
  useEffect(() => {
    const data: any = {
      first: "Medicine Master"
    };
    dispatch(Change(data));
  }, [dispatch,show]);
  // const onHandleChange = (event) => {
  //   const { name, value } = event.target;
  //   if (name === "date") {
  //     setDate({
  //       startDate: moment(value[0]).format("YYYY-MM-DD"),
  //       endDate: moment(value[1]).format("YYYY-MM-DD"),
  //     });
  //     setDateRange(value);
  //   } else if (name === "source") {
  //     setSource(value);
  //   }
  // };
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <React.Fragment>
      <div>
        <Toast open={open1} type={type} message={message} />

        <Row className="mb-3">
          <Col md={5} className="mb-3">
            <SearchBox
              value={searchValue}
              onChange={(event) => onChangeSearch(event)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <DashTabs
              show={show}
              setshow={setshow}
              handleOpen={handleOpen}
              onFilter={onFilter}
              setMedicine={setMedicine}
            />
          </Col>
          {/* <Col xs={12} md={12}>
          {PermissionCheck('ivf_journey_stages', 'add') && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <Button
                  variant="contained"
                  id="btn"
                  onClick={() => {
                    setshow(!show);
                  }}  
                >
{show ? "x Close" : "+ Add Medicine"}                </Button>
              </div>
            )}
          </Col> */}
        </Row>

        <div className="grid-container">
          <div className={show ? "item1" : "item1-full"}>
            <DashTable
              pagination={pagination}
              show={show}
              medicines={filteredValues ? filteredValues : medicines}
              deleted={deleted}
              setDeleted={setDeleted}
              setshow={setshow}
              setMedicine={setMedicine}
              refetch={refetch}
              updated={updated}
              setUpdated={setUpdated}
              openSnackBar={openSnackBar}
            />
            {!isLoading && (
              <Pagination
                setpagination={setpagination}
                pagination={pagination}
                data={medicines}
              />
            )}
          </div>
          {show ? (
            <div className="Customer-details mx-3 item2">
              <ul
                className="md-bord"
                style={{ height: "100%", maxHeight: "100%" }}
              >
                <MedicineDetails
                  medicine={medicine}
                  updated={updated}
                  setUpdated={setUpdated}
                  created={created}
                  setCreated={setCreated}
                  cancel={
                    <Button
                      variant="contained"
                      id="btn-cancel"
                      className="me-2"
                      onClick={() => {
                        setshow(!show);
                        setMedicine(initialMedicine);
                      }}
                    >
                      Cancel
                    </Button>
                  }
                  show={show}
                  setshow={setshow}
                />
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default React.memo(Medicinemaster);
